<template>
  <div v-if="broadcast">
    <v-container>
      <v-layout mb-3 align-center>
        <v-flex lg-9>
          <div style="display: flex; gap: 5px">
            <img
              @click="onBack"
              src="/static/img/arrow_back.png"
              alt
              class="responsive-img pointer"
              style="height: 24px; margin-top: 5px"
            />
            <div style="flex-wrap: wrap; width: 80%">
              <Typography h2 bold :label="name" />
            </div>
          </div>
        </v-flex>
        <v-flex lg-3 class="text-right">
          <v-chip color="#52C41A" text-color="white" small disabled>BROADCASTED</v-chip>
        </v-flex>
      </v-layout>

      <v-card elevation="2" style="border-radius: 10px">
        <v-container pt-0 pb-0 pl-3 pr-3>
          <v-tabs
            v-model="viewPage"
            color="white"
            :slider-color="$vuetify.theme.primary"
            style="font-size: 18px"
          >
            <v-tab
              v-for="(item, index) in menuItem"
              :key="`menu-item-${index}`"
              style="text-transform: capitalize"
              ripple
              :href="`#${item.view}`"
              @click="updateSlug(item.view)"
              >{{ item.text }}</v-tab
            >
          </v-tabs>
        </v-container>

        <Detail
          v-if="view == 'detail'"
          :value="value"
          :broadcastType="'sent'"
          @showEditNameModal="showEditNameModal = true"
          @showEditTarget="showEditTarget = true"
          @showEditTags="showEditTags = true"
          @showEditTimeSchedule="showEditTimeSchedule = true"
        />

        <MessageTab v-if="view == 'message'" :value="broadcast" :broadcastType="'broadcasted'">
          <broadcast-answers-message
            slot="message"
            v-model="messages"
            :broadcast="broadcast"
            :choice="choices"
            :questions="questions"
            :isComment="false"
            :comment="''"
            :broadcastType="'broadcasted'"
            @onSave="onSave"
          >
            <div v-if="choices.length > 0" slot="tags" style="display: flex; flex-wrap: wrap; gap: 7px">
              <div v-for="(choice, index) in choices" :key="'choice' + index">
                <span
                  style="
                    margin-bottom: 7px;
                    display: flex;
                    border: 1px solid #0c2f53;
                    background-color: #e6f0fb;
                    border-radius: 6px;
                    padding: 5px 10px;
                    white-space: nowrap;
                  "
                >
                  <typography h6 :color="color - darkBlue" :label="choice.text" />
                </span>
              </div>
            </div>
            <div v-else slot="tags" style="display: flex;"> 
              <typography h6 color="color-mediumGrey" label="ไม่มีตัวเลือก" />
            </div>
          </broadcast-answers-message>
        </MessageTab>
      </v-card>
    </v-container>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import Typography from '@/components/elements/Typography.vue'
import api from '@/api'
import Detail from './Detail'
import MessageTab from './Message'
import BroadcastAnswersMessage from './BroadcastAnswersMessage.vue'

export default {
  props: ['value'],
  data: function () {
    return {
      showEditNameModal: false,
      showEditTarget: false,
      showEditTags: false,
      showEditTimeSchedule: false,
      menuData: [
        {
          text: this.$t('broadcast tab detail'),
          view: 'detail',
        },
        {
          text: this.$t('broadcast tab message'),
          view: 'message',
        },
      ],
      viewPage: 'detail',
      broadcast: undefined,
      update_status: '',
      update_tags: [],
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      intents: [],
      type: 'text',
      groupType: '',
      sendtype: 'subscription',
      pushtype: 'regular',
      message: '',
      quick_reply: '',
      typeOptions: [
        {
          value: 'text',
          name: 'Text',
        },
        {
          value: 'template',
          name: 'Generic',
        },
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        },
      ],
      messages: [],
      filter: {
        fullname: '',
        gender: 'all',
        locale: null,
        app: 'all',
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: '',
        },
        timezone: {
          from: -12,
          to: 14,
        },
        activeDate: {
          enable: false,
          start: '',
          end: '',
        },
        registerDate: {
          enable: false,
          start: null,
          end: null,
        },
      },
    }
  },
  components: {
    GenericViewer,
    MessageViewer,
    Typography,
    Detail,
    MessageTab,
    BroadcastAnswersMessage,
  },
  mounted: function () {
    var vm = this
    vm.getIntent(function () {})
    vm.reset()

    if (this.value && this.value.m_condition) {
      let a = this.value.m_condition.split('&')
      let b = {}
      a.forEach((v) => {
        let x = v.split('=')
        b[x[0]] = x[1]
      })
      let c = {
        uu_areaname: b.uu_areaname,
        uu_dma: b.uu_dma,
        uu_name: b.uu_name,
        uu_register_status: b.uu_register_status,
      }
      Object.assign(this.filter, c)
    }
  },
  computed: {
    choices: {
      get() {
        let vm = this
        if (vm.quick_reply && vm.quick_reply !== '') {
          var quickReplies = []
          quickReplies = vm.quick_reply.split(',')
          var result = []
          if (quickReplies) {
            quickReplies.map(function (val, index) {
              result.push({ text: val })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (val, index) {
            result.push(val.text)
          })
        }
        vm.quick_reply = result.join(',')
      },
    },
    menuItem() {
      if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
        return this.menuData.filter((el) => {
          return ['couponreport', 'techproviderandproductreport'].includes(el.view)
        })
      } else {
        return this.menuData
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
    view() {
      var defaultview = 'detail'
      if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
        defaultview = 'couponreport'
      }
      this.viewPage = this.$route.query.view ? this.$route.query.view : defaultview
      return this.$route.query.view ? this.$route.query.view : defaultview
    },
    filterIntent: function () {
      var vm = this
      vm.intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
          return 1
        }
        if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      if (vm.intents) {
        vm.intents.map(function (intent, index) {
          intents.push(intent.intentname)
        })
      }
      return intents
    },
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    },
    reset: function () {
      var vm = this
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)
      }
      if (vm.broadcast) {
        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter((el) => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters.map(function (filter, index) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              switch (value[0]) {
                case 'fullname':
                case 'gender':
                case 'app':
                case 'email':
                case 'status':
                case 'tags':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  return { id: value[0], value: value[1] }
                  break
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: messagesent[0] + '__',
                  }
                  return {
                    id: value[0],
                    value: {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__',
                    },
                  }
                  break
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  vm.filter.locale = vm.localeOptions
                    .map((configLocal, clindex) => {
                      if (locales.includes(configLocal.value)) {
                        return configLocal
                      } else {
                        return null
                      }
                    })
                    .filter((el) => {
                      return el != null
                    })
                  return { id: 'locale', value: vm.filter.locale }
                  break
                case 'intent':
                  vm.filter.intent = value[1].split(',')
                  return { id: 'intent', value: value[1].split(',') }
                  break
                case 'timestamp_from':
                  vm.filter.activeDate.start = moment(value[1]).toDate()
                  return { id: 'activeDate_start', value: moment(value[1]).toDate() }
                  break
                case 'timestamp_to':
                  vm.filter.activeDate.end = moment(value[1]).toDate()
                  return { id: 'activeDate_end', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = moment(value[1]).toDate()
                  return { id: 'registerDate_start', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = moment(value[1]).toDate()
                  return { id: 'registerDate_end', value: moment(value[1]).toDate() }
                  break
              }
            }
          })

          if (f.length == 1 && (vm.filter['app'] == 'facebook' || vm.filter['app'] == 'line')) {
            vm.groupType = vm.filter['app']
          } else {
            vm.groupType = 'customize'
          }
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype
        vm.pushtype = vm.broadcast.pushtype

        this.update_status = vm.broadcast.update_user_status
        try {
          this.update_tags = vm.broadcast.update_user_tags.split(',')
          this.update_tags = this.update_tags.filter((el) => {
            return el != ''
          })
          // this.tagOptions = this.update_tags
        } catch (error) {}

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square',
              },
            ],
          ]
        } else if (vm.broadcast.m_type == 'json') {
          vm.messages = JSON.parse(vm.broadcast.m_val)
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function (index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function (index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message,
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button',
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message,
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message,
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = undefined
      }
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid,
      }
      api.getIntent(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function (index, val) {
            var intent = val
            intent.isShow = false
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    onBack: function () {
      var vm = this
      let current = this.$router.history.current.path
      this.$router.push(current)
      vm.$emit('onClose')
    },
  },
  watch: {
    value: function () {
      this.reset()
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastView.vue